import type { Dict } from "../lib/i18n";

// Subscription, paywall and trial wording. Keys: plans.*, paywall.*, trial.*, home.plus*
export default {
  zh: {
    "plans.intro": "购物清单、会员卡包、附近商家和邻里分享永久免费，不用订阅。订阅 Plus 解锁家庭账本、拍小票记账、饮食（热量和糖）、食材库、物品库和 AI 估算。",
    "plans.status.trialEnded": "免费试用已结束。购物清单、会员卡包、附近商家和邻里分享仍可继续免费使用。",
    "paywall.body": "订阅 NutriCart Plus 即可使用，推荐年订阅。购物清单、会员卡包、附近商家和邻里分享永久免费。",
    "plans.status.family": "你在用家庭的 Plus（由家里订阅的人支付），所有功能都能用。",
    "paywall.what.wallet": "把超市会员卡存进手机，结账时直接出示条码。",
    "paywall.what.ledger": "记下每一笔开销，自动分类，看每月花在哪里、离预算还有多少。",
    "paywall.what.receipt": "拍下购物小票，AI 自动读出金额和每样商品，并和购物清单一一对应，退瓶退款也不会忘。",
    "paywall.what.meals": "扫条码或拍一下饭菜，就知道这一餐占一天所需的多少；还有轻断食、体重记录和每月 Excel 报告。",
    "paywall.what.places": "找附近的超市和商家，看营业时间和优惠。",
    "paywall.what.board": "和邻居分享美食、交换闲置、互相帮忙。",
    "paywall.what.fridge": "家里的食材一目了然：每样的碳水、糖、盐和脂肪，快过期的提醒你吃掉或扔掉，快用完的自动加入购物清单；做菜时按食材精确算出每份的营养。",
    "paywall.toMe": "去“我的”",
    "plans.title": "NutriCart Plus 会员",
    "plans.free": "永久免费",
    "plans.free.price": "€0",
    "plans.free.f1": "购物清单，不限数量",
    "plans.free.f2": "语音和批量添加商品",
    "plans.free.f3": "出门小叮咛",
    "plans.free.f4": "会员卡包：存好所有会员卡，结账直接出示条码",
    "plans.free.f5": "附近商家：地图上找附近的超市和店铺",
    "plans.plus": "Plus",
    "plans.month": "按月",
    "plans.year": "按年",
    "plans.price.month": "€9.99",
    "plans.price.month.per": "/ 月",
    "plans.price.year": "€89",
    "plans.price.year.per": "/ 年",
    "plans.price.year.note": "相当于每月 €7.42，省 26%",
    "plans.founder": "🌱 创始会员价：€69 / 年，以后续费也一直是 €69。前 100 名，还剩 {n} 个名额。",
    "plans.founderWas": "原价 €89",
    "plans.recommended": "推荐 · 最划算",
    "plans.plus.f1": "永久免费的全部功能",
    "plans.plus.f2": "邻里分享：和邻居分享美食、交换闲置",
    "plans.plus.f3": "家庭账本：拍小票记账、预算、月度和季度报表、Excel 导出",
    "plans.plus.f4": "饮食：三餐记录、营养标签识别、运动消耗、体重和月度 Excel 报告",
    "plans.plus.f5": "AI 帮你读会员卡和难认的食品包装",
    "plans.plus.f6": "拍一下，估算你每餐的卡路里和碳水摄入（每天 {food} 次）；小票和食品包装随拍随读",
    "plans.subscribe": "订阅 Plus",
    "plans.subscribeTrial": "订阅 Plus（试用结束后才扣款）",
    "plans.manage": "管理订阅",
    "plans.manageHint": "在 Stripe 的安全页面里更换付款方式、切换按月/按年、下载发票或取消订阅。",
    "plans.current": "当前方案",
    "plans.status.trial": "免费试用中，还剩 {days} 天（到 {date}）",
    "plans.status.active": "已订阅 Plus（{interval}），下次续费日期 {date}",
    "plans.status.cancelling": "Plus 会在 {date} 到期，之后不会再扣款。",
    "plans.status.pastDue": "上次扣款没有成功。请在“管理订阅”里更新付款方式，以免功能被锁。",
    "plans.status.manual": "你的 Plus 由管理员赠送，没有截止日期。",
    "plans.status.manualUntil": "你的 Plus 由管理员赠送，到 {date} 为止。",
    "plans.status.admin": "你是管理员，可以使用全部功能。",
    "plans.trialNote": "新用户免费试用全部功能 {days} 天，不需要绑卡。试用期间每天可用 AI 拍照估算 1 餐，订阅后每天 3 餐。试用期间订阅，剩余的试用天数照样保留。",
    "plans.secure": "付款由 Stripe 安全处理，支持银行卡、iDEAL、Apple Pay、Google Pay 等。可以随时取消。",
    "plans.notConfigured": "在线支付正在准备中。想现在开通 Plus，请联系我们。",
    "plans.checkoutSuccess": "订阅成功，谢谢你的支持！",
    "plans.checkoutPending": "付款已完成，正在确认订阅…",
    "plans.checkoutCancelled": "已取消付款，没有扣款。",
    "plans.limit.title": "AI 使用次数",
    "plans.limit.trial": "试用期",
    "plans.limit.perDay": "每天 {n} 次",
    "plans.limit.perMonth": "每月 {n} 次",
    "plans.limit.food": "拍照估算饭菜",
    "plans.limit.advice": "记账建议",
    "plans.limit.total": "AI 总次数（拍餐 + 记账建议）",
    "plans.limit.reads": "AI 帮读小票、营养表、会员卡（手机读不出来时）",
    "plans.limit.note": "每天的次数 0 点重新计算，每月的次数 1 日重新计算。在“我的 → AI 使用情况”随时能看到用了多少、还剩多少。",
    "plans.quota": "AI 次数按自然月计算，每月 1 日重置；试用期间每月 {trial} 次。同一张照片重复识别不额外计次。",

    "paywall.title": "{feature}是 Plus 会员功能",
    "paywall.trialEnded": "你的 {days} 天免费试用已结束，之前记录的数据都还在，订阅后即可继续使用。",
    "paywall.cta": "查看订阅方案",
    "paywall.export": "之前记录的数据都还在，可以在“我的”里随时导出。",
    "paywall.feature.wallet": "会员卡包",
    "paywall.feature.ledger": "家庭账本",
    "paywall.feature.meals": "饮食",
    "paywall.feature.places": "附近商家",
    "paywall.feature.board": "邻里分享",
    "paywall.feature.fridge": "食材库",
    "paywall.feature.goods": "家庭物品库",
    "paywall.what.goods": "衣服鞋帽、日用品、电器工具等不是食品的东西，从小票自动整理；看每月花费曲线，重复购买前会提醒你。",
    "paywall.feature.receipt": "拍小票记账",

    "trial.banner": "免费试用还剩 {days} 天",
    "trial.bannerLast": "免费试用今天结束",
    "trial.bannerCta": "订阅 Plus",
    "trial.endedBanner": "免费试用已结束，购物清单仍可免费使用",
    "trial.endedCta": "解锁全部功能",
    "home.plus": "Plus 会员",
    "home.plus.sub": "解锁全部功能",
    "home.locked": "Plus",

    "admin.stat.subscribers": "付费订阅",
    "admin.stat.manualPlus": "手动开通 Plus",
    "admin.stat.inFreeTrial": "试用中",

  },
  en: {
    "plans.intro": "The shopping list, loyalty cards, shops nearby and the neighbourhood board are free forever, no subscription needed. Plus unlocks the household budget, receipt scanning, calories & sugar, the pantry, home goods and AI estimates.",
    "plans.status.trialEnded": "Your free trial has ended. The shopping list, loyalty cards, shops nearby and the neighbourhood board stay free.",
    "paywall.body": "Subscribe to NutriCart Plus to use it; the yearly plan is the best value. The shopping list, loyalty cards, shops nearby and the neighbourhood board are free forever.",
    "plans.status.family": "You're using the family's Plus (paid by whoever in the family subscribed): everything is unlocked.",
    "plans.status.manualUntil": "Your Plus was given to you by the team, until {date}.",
    "paywall.what.wallet": "Keep your loyalty cards on your phone and show the barcode at checkout.",
    "paywall.what.ledger": "Log every expense, sorted automatically: see where the month's money goes and how much budget is left.",
    "paywall.what.receipt": "Photograph a receipt: AI reads the total and every item, matches it to your shopping list and remembers bottle deposits.",
    "paywall.what.meals": "Scan a barcode or snap your plate to see how much of your day one meal is — plus fasting, a weight log and a monthly Excel report.",
    "paywall.what.places": "Find supermarkets and shops nearby, with opening hours and offers.",
    "paywall.what.board": "Share food, swap things and help each other out with neighbours.",
    "paywall.what.fridge": "See everything at home with its carbs, sugar, salt and fat. Get told what to use up or throw away, have what runs out put on the shopping list, and work out each serving of a dish exactly from its ingredients.",
    "paywall.toMe": "Go to Me",
    "plans.title": "NutriCart Plus",
    "plans.free": "Free forever",
    "plans.free.price": "€0",
    "plans.free.f1": "Shopping list, as many items as you like",
    "plans.free.f2": "Add items by voice or in a batch",
    "plans.free.f3": "Before-you-go reminders",
    "plans.free.f4": "Loyalty cards: keep them all and show the barcode at the till",
    "plans.free.f5": "Shops nearby: find supermarkets and shops on the map",
    "plans.plus": "Plus",
    "plans.month": "Monthly",
    "plans.year": "Yearly",
    "plans.price.month": "€9.99",
    "plans.price.month.per": "/ month",
    "plans.price.year": "€89",
    "plans.price.year.per": "/ year",
    "plans.price.year.note": "€7.42 a month, save 26%",
    "plans.founder": "🌱 Founding member price: €69 / year, and it stays €69 on every renewal. First 100 members — {n} places left.",
    "plans.founderWas": "normally €89",
    "plans.recommended": "Recommended · best value",
    "plans.plus.f1": "Everything that is free forever",
    "plans.plus.f2": "Neighbourhood board: share food and swap things with neighbours",
    "plans.plus.f3": "Household budget: receipt scanning, budgets, monthly and quarterly reports, Excel export",
    "plans.plus.f4": "Calories & sugar: meal log, label reading, goals",
    "plans.plus.f5": "AI reads loyalty cards and hard-to-read food labels for you",
    "plans.plus.f6": "Snap a photo to estimate the calories and carbs of each meal ({food} a day); receipts and food labels read as you snap them",
    "plans.subscribe": "Subscribe to Plus",
    "plans.subscribeTrial": "Subscribe to Plus (first payment when your trial ends)",
    "plans.manage": "Manage subscription",
    "plans.manageHint": "On Stripe's secure page you can change your card, switch between monthly and yearly, download invoices or cancel.",
    "plans.current": "Your plan",
    "plans.status.trial": "Free trial: {days} days left (until {date})",
    "plans.status.active": "Plus ({interval}), renews on {date}",
    "plans.status.cancelling": "Plus ends on {date}. You won't be charged again.",
    "plans.status.pastDue": "The last payment didn't go through. Update your payment method under Manage subscription to keep access.",
    "plans.status.manual": "Plus was switched on for you by an admin.",
    "plans.status.admin": "You're an admin, so everything is unlocked.",
    "plans.trialNote": "New accounts can try everything free for {days} days, no card needed. During the trial you can estimate 1 meal a day by photo; with Plus, 3. Subscribe during the trial and you keep the remaining trial days.",
    "plans.secure": "Payments are handled securely by Stripe: cards, iDEAL, Apple Pay, Google Pay and more. Cancel any time.",
    "plans.notConfigured": "Online payment is being set up. Contact us if you'd like Plus now.",
    "plans.checkoutSuccess": "You're subscribed. Thank you for your support!",
    "plans.checkoutPending": "Payment done, confirming your subscription…",
    "plans.checkoutCancelled": "Payment cancelled. You haven't been charged.",
    "plans.limit.title": "AI limits",
    "plans.limit.trial": "Trial",
    "plans.limit.perDay": "{n} a day",
    "plans.limit.perMonth": "{n} a month",
    "plans.limit.food": "Meal photo estimates",
    "plans.limit.advice": "Spending advice",
    "plans.limit.total": "AI in total (meal photos + advice)",
    "plans.limit.reads": "AI reading help for receipts, labels, cards (when the phone can't)",
    "plans.limit.note": "Daily limits reset at midnight, monthly ones on the 1st. See what you've used and what's left any time under Me → AI use.",
    "plans.quota": "AI reads reset on the 1st of each month; during the trial you get {trial} a month. Reading the same photo again is free.",

    "paywall.title": "{feature} is part of Plus",
    "paywall.trialEnded": "Your {days}-day free trial has ended. Everything you recorded is still here; subscribe to carry on.",
    "paywall.cta": "See plans",
    "paywall.export": "Everything you recorded is kept; you can export it from Me at any time.",
    "paywall.feature.wallet": "Loyalty cards",
    "paywall.feature.ledger": "The household budget",
    "paywall.feature.meals": "Meals",
    "paywall.feature.places": "Shops nearby",
    "paywall.feature.board": "The neighbourhood board",
    "paywall.feature.fridge": "Pantry",
    "paywall.feature.goods": "Home goods",
    "paywall.what.goods": "Clothes, household products, electronics and tools sorted from your receipts by themselves; a monthly spending curve, and a reminder before you buy the same again.",
    "paywall.feature.receipt": "Receipts",

    "trial.banner": "{days} days left in your free trial",
    "trial.bannerLast": "Your free trial ends today",
    "trial.bannerCta": "Subscribe",
    "trial.endedBanner": "Your free trial has ended. The shopping list stays free.",
    "trial.endedCta": "Unlock everything",
    "home.plus": "Plus",
    "home.plus.sub": "Unlock everything",
    "home.locked": "Plus",

    "admin.stat.subscribers": "Paying subscribers",
    "admin.stat.manualPlus": "Plus granted by admin",
    "admin.stat.inFreeTrial": "In free trial",

  },
  nl: {
    "plans.intro": "De boodschappenlijst, klantenkaarten, winkels in de buurt en het buurtprikbord zijn altijd gratis, zonder abonnement. Met Plus krijg je het huishoudboekje, bonnetjes scannen, calorieën & suiker, de voorraad, spullen in huis en AI-schattingen.",
    "plans.status.trialEnded": "Je gratis proefperiode is afgelopen. De boodschappenlijst, klantenkaarten, winkels in de buurt en het buurtprikbord blijven gratis.",
    "paywall.body": "Abonneer op NutriCart Plus om dit te gebruiken; het jaarabonnement is het voordeligst. De boodschappenlijst, klantenkaarten, winkels in de buurt en het buurtprikbord zijn altijd gratis.",
    "plans.status.family": "Je gebruikt de Plus van het gezin (betaald door wie in het gezin geabonneerd is): alles is ontgrendeld.",
    "plans.status.manualUntil": "Je Plus is je cadeau gegeven door het team, tot en met {date}.",
    "paywall.what.wallet": "Bewaar je klantenkaarten op je telefoon en laat de barcode zien bij de kassa.",
    "paywall.what.ledger": "Houd elke uitgave bij, automatisch ingedeeld: zie waar het geld heen gaat en hoeveel budget er over is.",
    "paywall.what.receipt": "Fotografeer een kassabon: AI leest het totaal en elk product, koppelt het aan je boodschappenlijst en onthoudt statiegeld.",
    "paywall.what.meals": "Scan een barcode of fotografeer je bord en zie hoeveel van je dag één maaltijd is — plus vasten, gewicht en een maandrapport in Excel.",
    "paywall.what.places": "Vind supermarkten en winkels in de buurt, met openingstijden en aanbiedingen.",
    "paywall.what.board": "Deel eten, ruil spullen en help elkaar met je buren.",
    "paywall.what.fridge": "Zie alles wat je in huis hebt, met koolhydraten, suiker, zout en vet. Krijg een seintje wat op moet of weg moet, laat wat opraakt op het boodschappenlijstje zetten en bereken elke portie precies uit de ingrediënten.",
    "paywall.toMe": "Naar Ik",
    "plans.title": "NutriCart Plus",
    "plans.free": "Altijd gratis",
    "plans.free.price": "€0",
    "plans.free.f1": "Boodschappenlijst, zoveel items als je wilt",
    "plans.free.f2": "Items toevoegen met je stem of in één keer",
    "plans.free.f3": "Herinneringen voor je de deur uitgaat",
    "plans.free.f4": "Klantenkaarten: bewaar ze allemaal en laat de streepjescode zien bij de kassa",
    "plans.free.f5": "Winkels in de buurt: vind supermarkten en winkels op de kaart",
    "plans.plus": "Plus",
    "plans.month": "Per maand",
    "plans.year": "Per jaar",
    "plans.price.month": "€9,99",
    "plans.price.month.per": "/ maand",
    "plans.price.year": "€89",
    "plans.price.year.per": "/ jaar",
    "plans.price.year.note": "€7,42 per maand, 26% voordeliger",
    "plans.founder": "🌱 Oprichtersprijs: €69 per jaar, en dat blijft €69 bij elke verlenging. Eerste 100 leden — nog {n} plaatsen.",
    "plans.founderWas": "normaal €89",
    "plans.recommended": "Aanbevolen · voordeligst",
    "plans.plus.f1": "Alles wat altijd gratis is",
    "plans.plus.f2": "Buurtprikbord: eten delen en spullen ruilen met buren",
    "plans.plus.f3": "Huishoudboekje: bonnetjes scannen, budgetten, maand- en kwartaaloverzichten, Excel-export",
    "plans.plus.f4": "Calorieën & suiker: maaltijden bijhouden, labels lezen, doelen",
    "plans.plus.f5": "AI leest klantenkaarten en lastige etiketten voor je",
    "plans.plus.f6": "Maak een foto en schat de calorieën en koolhydraten van elke maaltijd ({food} per dag); bonnen en etiketten worden direct gelezen",
    "plans.subscribe": "Abonneer op Plus",
    "plans.subscribeTrial": "Abonneer op Plus (eerste betaling als je proefperiode afloopt)",
    "plans.manage": "Abonnement beheren",
    "plans.manageHint": "Op de beveiligde pagina van Stripe kun je je betaalmethode wijzigen, wisselen tussen maand en jaar, facturen downloaden of opzeggen.",
    "plans.current": "Jouw abonnement",
    "plans.status.trial": "Gratis proefperiode: nog {days} dagen (tot {date})",
    "plans.status.active": "Plus ({interval}), wordt verlengd op {date}",
    "plans.status.cancelling": "Plus stopt op {date}. Je betaalt daarna niets meer.",
    "plans.status.pastDue": "De laatste betaling is niet gelukt. Werk je betaalmethode bij onder Abonnement beheren om toegang te houden.",
    "plans.status.manual": "Plus is voor je aangezet door een beheerder.",
    "plans.status.admin": "Je bent beheerder, dus alles staat open.",
    "plans.trialNote": "Nieuwe accounts kunnen alles {days} dagen gratis proberen, zonder betaalgegevens. Tijdens de proefperiode kun je 1 maaltijd per dag met een foto laten schatten; met Plus 3. Abonneer je tijdens de proefperiode, dan houd je de resterende dagen.",
    "plans.secure": "Betalingen worden veilig verwerkt door Stripe: pinpas, creditcard, iDEAL, Apple Pay, Google Pay en meer. Altijd opzegbaar.",
    "plans.notConfigured": "Online betalen wordt nog ingericht. Neem contact op als je nu al Plus wilt.",
    "plans.checkoutSuccess": "Je bent geabonneerd. Bedankt voor je steun!",
    "plans.checkoutPending": "Betaling gelukt, abonnement wordt bevestigd…",
    "plans.checkoutCancelled": "Betaling geannuleerd. Er is niets afgeschreven.",
    "plans.limit.title": "AI-limieten",
    "plans.limit.trial": "Proefperiode",
    "plans.limit.perDay": "{n} per dag",
    "plans.limit.perMonth": "{n} per maand",
    "plans.limit.food": "Maaltijdfoto's schatten",
    "plans.limit.advice": "Uitgavenadvies",
    "plans.limit.total": "AI in totaal (maaltijdfoto's + advies)",
    "plans.limit.reads": "AI-leeshulp voor bonnen, etiketten, kaarten (als de telefoon het niet kan)",
    "plans.limit.note": "Daglimieten beginnen om 0:00 opnieuw, maandlimieten op de 1e. Onder Ik → AI-gebruik zie je altijd wat je gebruikt hebt en wat er nog over is.",
    "plans.quota": "AI-scans beginnen op de 1e van elke maand opnieuw; tijdens de proefperiode krijg je er {trial} per maand. Dezelfde foto opnieuw lezen is gratis.",

    "paywall.title": "{feature} hoort bij Plus",
    "paywall.trialEnded": "Je gratis proefperiode van {days} dagen is afgelopen. Alles wat je hebt bijgehouden staat er nog; abonneer om verder te gaan.",
    "paywall.cta": "Bekijk abonnementen",
    "paywall.export": "Alles wat je hebt vastgelegd blijft bewaard; je kunt het altijd exporteren via Ik.",
    "paywall.feature.wallet": "Klantenkaarten",
    "paywall.feature.ledger": "Het huishoudboekje",
    "paywall.feature.meals": "Eten",
    "paywall.feature.places": "Winkels in de buurt",
    "paywall.feature.board": "Het buurtprikbord",
    "paywall.feature.fridge": "Voorraad",
    "paywall.feature.goods": "Spullen in huis",
    "paywall.what.goods": "Kleding, huishoudproducten, elektronica en gereedschap vanzelf gesorteerd uit je bonnen; een maandcurve van de uitgaven, en een seintje voordat je hetzelfde nog eens koopt.",
    "paywall.feature.receipt": "Kassabonnen",

    "trial.banner": "Nog {days} dagen gratis proberen",
    "trial.bannerLast": "Je gratis proefperiode eindigt vandaag",
    "trial.bannerCta": "Abonneren",
    "trial.endedBanner": "Je gratis proefperiode is afgelopen. De boodschappenlijst blijft gratis.",
    "trial.endedCta": "Alles ontgrendelen",
    "home.plus": "Plus",
    "home.plus.sub": "Alles ontgrendelen",
    "home.locked": "Plus",

    "admin.stat.subscribers": "Betalende abonnees",
    "admin.stat.manualPlus": "Plus via beheerder",
    "admin.stat.inFreeTrial": "In proefperiode",

  },
} satisfies Dict;
